import React, { useState, useEffect } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const PerformanceDonut = (props) => {
    var totalApplied = {
        name: "CV Submissions",
        value: 36,
        color: "#2bb4b0",
    };

    const [options, setOptions] = useState({
        chart: {
            type: "pie",
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
        },
        title: {
            verticalAlign: "middle",
            floating: true,
            text:
                '<span className="custom-title"><span>' +
                totalApplied.value +
                "</span><br></span>",
            useHTML: true,
        },
        tooltip: {
            enabled: false,
        },

        credits: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                innerSize: "75%",
                size: "100%",
                colors: ["#2bb4b0", "#2f9cca", "#f59e0d", "#283270", "#bcbcbb"],
            },
            series: {
                states: {
                    hover: {
                        enabled: false,
                    },
                    inactive: {
                        opacity: 1,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
            },
        },

        series: [
            {
                data: props.data,
            },
        ],
    });

    useEffect(() => {
        if (Object.keys(props.data).length > 0) {

            const totalVal = parseInt(props.data[0][0]) + parseInt(props.data[1][0]) + parseInt(props.data[2][0])

            setOptions({
                chart: {
                    type: "pie",
                    margin: [0, 0, 0, 0],
                    spacingTop: 0,
                    spacingBottom: 0,
                    spacingLeft: 0,
                    spacingRight: 0,
                },
                title: {
                    verticalAlign: "middle",
                    floating: true,
                    text:
                        '<span className="custom-title"><span>' +
                        totalVal +
                        "</span><br></span>",
                    useHTML: true,
                },
                tooltip: {
                    enabled: false,
                },

                credits: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        innerSize: "75%",
                        size: "100%",
                        colors: ["#2bb4b0", "#2f9cca", "#f59e0d", "#283270", "#bcbcbb"],
                    },
                    series: {
                        states: {
                            hover: {
                                enabled: false,
                            },
                            inactive: {
                                opacity: 1,
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                    },
                },

                series: [
                    {
                        data: props.data,
                    },
                ],
            });
        }
    }, [props]);

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            containerProps={{ className: "custom-circle-progress label-center" }}
        />
    );
};

export default PerformanceDonut;
